import React, { useState } from 'react';
import CusInput from './CusInput';
import { IconButton, InputAdornment, Stack } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import ShowContainer from './ShowContainer';
import { IconCopy } from '@tabler/icons-react';
import useToast from '../../hooks/useToast';
import { useLocalStorage } from 'usehooks-ts';
import { ENUM_LOCALSTORAGE } from '../../enums/enums';

export default function CusPassword({
  isCopyClick,
  autoComplete = 'current-password',
  autoFocus,
  ...props
}) {
  const [isPass, setIsPass] = useLocalStorage(ENUM_LOCALSTORAGE.showPas, false);
  const { infoToast } = useToast();

  const onCopyClick = () => {
    navigator.clipboard.writeText(props.value).then((e) => {
      infoToast('copied to your clipboard');
    });
  };

  return (
    <>
      {!isPass && (
        <input
          {...props}
          type="password"
          className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-xl focus:outline-none focus:border-blue-500"
          placeholder="Введите пароль"
          autoComplete={autoComplete}
          style={{ position: 'absolute', opacity: 0, zIndex: -1 }}
        />
      )}
      <CusInput
        {...props}
        type={isPass ? 'password' : 'text'}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        endAdornment={
          <InputAdornment position="end">
            <Stack direction={'row'} gap={0.5} alignItems={'center'}>
              <ShowContainer condition={isCopyClick}>
                <IconButton
                  onMouseDown={(e) => e.preventDefault()}
                  edge="end"
                  size="small"
                  onClick={onCopyClick}>
                  <IconCopy width={14} height={14} />
                </IconButton>
              </ShowContainer>
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setIsPass(!isPass)}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
                size="small">
                {isPass ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </Stack>
          </InputAdornment>
        }
      />
    </>
  );
}
